
import * as GrapeSettings from '../lib/grape_settings.js';

/**
 * Cache to register commonly used system settings
 * @kind cache
 * @class SettingsLookup
 * @description Custom lookup cache for Settings
 * @usage Grape.cache.fetch('SettingsLookup', function(data) { });
 */
export default {
	name: 'SettingsLookup',
	options: {
		refresh: async function (cb) {
			let data = {};

			// TODO: Get single API to aggregate all of these in one call
			try
			{
				data.wizard = await GrapeSettings.wizard();
				data.wizard_all_tasks_done = await GrapeSettings.wizard_all_tasks_done();

				cb(null, data);
			}
			catch (e)
			{
				cb(e, null);
			}
		}
	}
};
